import { ReactElement } from "react";
import styles from "./ProductionFact.module.scss";

interface ProductionFactProps
{
    label: string;
    value: string;
}

const ProductionFact = (props: ProductionFactProps): ReactElement =>
{
    return (
        <div className={styles.productionFact}>
            <span className={styles.label}>{props.label}</span>
            <span className={styles.value}>{props.value}</span>
        </div>
    );
}

export default ProductionFact;